// extracted by mini-css-extract-plugin
export default {"popover-additional":"M9Fd5","active":"E_nEi","drawer":"wnu5U","drawer-mobile":"qucRF","additional-info-wrapper":"AeqHp","main":"ftJAy"};